import IconLoader from "@/features/Common/components/IconLoader";
import Panel from "@/features/Common/components/Panel";
import { trackUserInteraction } from "@/services/analytics-adapter";
import { panelStyle } from "@/theme";
import { convertPxToRem } from "@/utils";
import { Stack, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  FeatureToggleIdentifier,
  isFeatureEnabled,
} from "@/services/feature-toggle-adapter";

export default function PersonalizedPanel() {
  const isTrendedVitalsEnabled = isFeatureEnabled(
    FeatureToggleIdentifier.ENABLE_TRENDED_VITALS
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack
      sx={{
        ...panelStyle,
        cursor: "pointer",
        border: "none",
      }}
      component="button"
      role="button"
      aria-label={t("PersonalizedHealth.label")}
      spacing={1}
      onClick={() => {
        trackUserInteraction({
          linkText: "Home screen | Get Your Personalized Health Score",
          linkIntent: "navigational",
          linkScope: "button",
        });
        navigate("/home/health-score");
      }}
    >
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        gap={2}
      >
        <Typography
          textAlign="left"
          variant={isTrendedVitalsEnabled ? "body1" : "h3"}
          fontWeight="bold"
          color="grey[700]"
        >
          {t("PersonalizedHealth.label")}
        </Typography>

        <Panel
          sx={{
            boxShadow: "none",
            height: "fit-content",
            paddingLeft: convertPxToRem(10),
            paddingRight: convertPxToRem(10),
            paddingTop: convertPxToRem(6),
            paddingBottom: convertPxToRem(6),
            backgroundColor: (theme: Theme) => theme.palette.accent1[700],
          }}
        >
          <Typography
            variant={isTrendedVitalsEnabled ? "body2" : undefined}
            fontWeight={600}
            color="white"
          >
            {t("common.free")}
          </Typography>
        </Panel>
      </Stack>

      <Stack
        style={{ marginTop: isTrendedVitalsEnabled ? convertPxToRem(9.5) : "" }}
        flexDirection="row"
        alignItems="center"
        width="100%"
      >
        <Typography variant="button" fontWeight={800} color="primary.main">
          {t("PersonalizedHealth.CTA")}
        </Typography>
        <IconLoader icon="ChevronNextIcon" sx={{ color: "primary.main" }} />
      </Stack>
    </Stack>
  );
}
